import aiStudioService from "@apis/aiStudioService";
import { useAppDispatch } from "@hooks/redux";
import useQueryParams from "@hooks/useQueryParams";
import { message } from "antd";
import { useEffect, useState } from "react";
import { Trans } from "react-i18next";
import { useLocation } from "react-router-dom";

export const useAiStudio = () => {
  const [downloadStatus, setDownloadStatus] = useState<any>("idle");

  const handleDownload = async (response: any, requestId: string) => {
    const disposition = response.headers["content-disposition"]; // "attachment;filename*=utf-8''Kalodata_Creator_2023-07-07_ID.xlsx";
    // 优先使用后端名称，前端命名兜底
    let fileName = `Kaloclip_${requestId}.xlsx`;
    const regex = /filename\*?=['"]?(?:UTF-\d['"]*)?(?:[^'"]*)?''([^'"\s]+)['"]?/i;
    const matches = regex.exec(disposition);
    if (matches && matches.length > 1) {
      const matchedFilename = decodeURIComponent(matches[1]);
      fileName = matchedFilename;
    }
    const url = window.URL.createObjectURL(new Blob([response.data]));

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    message.success(<Trans>Export success</Trans>);
  };

  const downloadVideoScriptAnalysis = async ({
    translate = false,
    activeScript = 0,
    videoId,
    videoSource,
  }: {
    translate: boolean;
    activeScript?: number;
    videoId: string;
    videoSource: string;
  }) => {
    try {
      setDownloadStatus("loading");
      const response: any = await aiStudioService.downloadVideoScriptAnalysis({
        id: videoId,
        translate,
        activeScript,
        videoSource,
      });
      await handleDownload(response, videoId);
      setDownloadStatus("succeeded");
    } catch (error) {
      console.error("Error downloading file:", error);
      setDownloadStatus("failed");
    }
  };

  const downloadVideoScriptGenerate = async ({
    translate = false,
    activeScript,
    requestIds,
  }: {
    translate: boolean;
    activeScript: number;
    requestIds: string[];
  }) => {
    try {
      setDownloadStatus("loading");
      const response: any = await aiStudioService.downloadVideoScriptGenerate({
        translate,
        activeScript,
        requestIds,
      });
      await handleDownload(response, requestIds[0]);
      setDownloadStatus("succeeded");
    } catch (error) {
      console.error("Error downloading file:", error);
      setDownloadStatus("failed");
    }
  };

  return {
    downloadVideoScriptAnalysis,
    downloadVideoScriptGenerate,
    downloadStatus,
  };
};

export const useAiStudioReady = (updateReady: Function, resetToInit?: Function) => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const [videoId, videoSource, country] = useQueryParams(["id", "videoSource", "country"]);

  useEffect(() => {
    dispatch(
      updateReady({
        videoId,
        videoSource,
        country,
      }),
    );
    return () => {
      if (resetToInit) {
        dispatch(resetToInit());
      }
    };
  }, [location, videoId, videoSource]);
};
